import { useState } from "react";
import { Dealership } from "../models/dealership";
import { fetchDealershipsByDN, fetchDealerships } from "../api/fetchDealerships";

function useDealership() {
    const [dealerships, setDealerships] = useState<Dealership[]>([]);
    const [dealership, setDealership] = useState<Dealership | null>(null);

    const getDealershipByDN = async (dn: string): Promise<Dealership | null> => {
        const dealership = await fetchDealershipsByDN(dn);
        setDealership(dealership);
        return dealership;
    }

    const getDealershipsByName = async (name: string): Promise<Dealership[]> => {
        const dealerships = await fetchDealerships(name);
        setDealerships(dealerships);
        return dealerships;
    }

    return { dealerships, dealership, getDealershipsByName, getDealershipByDN }
}

export default useDealership;